<div *ngIf="declaration" [@fadeInOut]>
    <div class="card card2 mb-md-3">
        <div class="card-content">
            <div class="container p-3">
                <div class="row px-2">
                    <div class="col-md col-sm-12 px-2 pr-md-3">
                        <div class="row tag"><span>Protocolo</span></div>
                        <div class="row informacao"><span>{{declaration.ansProtocol}}</span></div>
                    </div>
                    <div class="col-md col-sm-12 px-2 pr-md-3">
                        <div class="row tag"><span>Data e hora da solicitação</span></div>
                        <div class="row informacao"><span>
                                {{declaration.requestDate| date: 'dd/MM/yyyy - HH:mm'}}</span></div>
                    </div>
                    <div class="col-md col-sm-12 px-2 pr-md-3">
                        <div class="row tag"><span>Produto</span></div>
                        <div class="row informacao px-2 pr-md-3"><span>{{declaration.product}}</span></div>
                    </div>
                    <div class="col-md col-sm-12 px-2 pr-md-3">
                        <div class="row tag"><span>Modelo da declaração</span></div>
                        <div class="row informacao"><span>{{declaration.name}}</span></div>
                    </div>
                    <div class="col-md col-sm-12 action px-2 pr-md-3">
                        <button [id]="declaration.protocol" type="button" class="btn btn-primary btn-export"
                            (click)="download(declaration)" [disabled]="loading">
                            <span>Fazer Download</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<pdf-viewer [src]="pdfSrc" [original-size]="true" [render-text]="true" [rotation]="0" [show-all]="false"
    [fit-to-page]="true" [zoom]="0.95" [zoom-scale]="'page-width'" [stick-to-page]="true"
    [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="pdf-viewer"
    style="width: 100%; height: 70vh; overflow-x: hidden !important;" />